var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{attrs:{"title":"کاردکس","color":"cyan","disabled":!_vm.wareId},on:{"click":_vm.openInventory}},[_vm._v("fa-pallet")])}
var staticRenderFns = []

export { render, staticRenderFns }